/* -------------------------------- Layout ---------------------------------- */
import CalendarLayout from "@/layouts/calendar"

/* --------- Login/Logout/Register --------- */
import Login from "@/pages/Login/Login";
import ForgotPassword from "@/pages/Login/ForgotPassword";
import Register from "@/pages/Login/Register";
import InvitationCode from "@/pages/Login/InvitationCode";
import WaitingForAccount from "@/pages/Login/WaitingForAccount";

/* --------- Final version --------- */
import OverviewPage from "@/pages/OverviewPage";
import VisionboardPage from "@/pages/VisionboardPage";
import ChallengeCatalogPage from "@/pages/ChallengeCatalogPage";
import UserProfilePage from "@/pages/UserProfilePage";
import ManageLicensesPage from "@/pages/ManageLicensesPage";
import MyDay_Subpage from "@/pages/TodayPage/MyDay_Subpage";
// import WeekPlanner_Subpage from "@/pages/TodayPage/WeekPlanner_Subpage";
import MyDailyPriorities_Subpage from "@/pages/TodayPage/MyDailyPriorities_Subpage";
import GoalOverview from "@/pages/GoalOverview";
import TeamGoalPage from "@/pages/TeamGoalPage/index";
import DashboardPage from "@/pages/TeamGoalPage/DashboardPage";
// import TeamGoal_DashboardSubpage from "@/pages/TeamGoalPage/DashboardSubpage";
// import TeamGoal_KanbanSubpage from "@/pages/TeamGoalPage/KanbanSubpage";
import TeamGoal_TimelineSubpage from '@/pages/TeamGoalPage/TimelineSubpage'
import TeamGoal_ReportsSubpage from '@/pages/TeamGoalPage/ReportsSubpage'
import TeamGoal_SettingsSubpage from '@/pages/TeamGoalPage/SettingsSubpage'
import VisionboardOverviewPage from '@/pages/VisionboardOverviewPage'
import CalendarPage from '@/pages/CalendarPage/index'
import CalendarPage_ManageTimeSubpage from '@/pages/CalendarPage/ManageTimeSubpage'
import CalendarPage_ManageWeekSubpage from '@/pages/CalendarPage/ManageWeekSubpage'
// import CalendarPage_SidebarSubpage from '@/pages/CalendarPage/SidebarSubpage'
import TaskPage from '@/pages/TaskPage'
import ChallengePage from '@/pages/ChallengePage/index'
import Challenge_DashboardSubpage from '@/pages/ChallengePage/DashboardSubpage'
import Challenge_DiscussionSubpage from '@/pages/ChallengePage/DiscussionSubpage'
import Challenge_CohortSubpage from '@/pages/ChallengePage/CohortSubpage'
import Challenge_SuccessStoriesSubpage from '@/pages/ChallengePage/SuccessStoriesSubpage'
import Challenge_SessionsSubpage from '@/pages/ChallengePage/SessionsSubpage'
import SequenceCreatorPage from '@/pages/SequenceCreatorPage/index'
import SequenceCreator_PreviewSubpage from '@/pages/SequenceCreatorPage/PreviewSubpage'
import SequenceCreator_EditorSubpage from '@/pages/SequenceCreatorPage/EditorSubpage'
import IdeasPage from "@/pages/IdeasPage"
import InvitationsPage from '@/pages/InvitationsPage'
import UserContactPage from "@/pages/UserContactPage";
import HelpPage from "@/pages/HelpPage"
import UpgradePage from "@/pages/UpgradePage"
import MostWantedFeaturePage from "@/pages/MostWantedFeaturePage"
import MessagesPage from "@/pages/MessagesPage"

/* --------- Draft version --------- */
import FocusPage from '@/pages/Draft/FocusPage'
// import ProjectLanesPage from "@/pages/Draft/ProjectLanesPage";
// import LanesPageAllGoals from "@/pages/Draft/LanesPageAllGoals";
import GoalPage from "@/pages/Draft/GoalPage";
import KanbanPage from "@/pages/Draft/KanbanPage";
import UserPage from "@/pages/Draft/UserPage";
// import CalendarPageDraft from "@/pages/Draft/CalendarPage";
import SessionPage from "@/pages/Draft/SessionPage";
import EggtimerPage from "@/pages/Draft/EggtimerPage";
import DailyChecklistPage from "@/pages/Draft/DailyChecklistPage";

/* --------- Development --------- */
// import ToDoList from "@/pages/Development/ToDoList";
// import TimelineDevPage from "@/pages/Development/TimelineDevPage";
import OptimizerDevPage from "@/pages/Development/OptimizerDevPage";
import GenericAPIDevPage from '@/pages/Development/GenericAPIDevPage'
// import RessourceDAGDevPage from '@/pages/Development/RessourceDAGDevPage'
import AsyncGetterDevPage from '@/pages/Development/AsyncGetterDevPage'
import RegistryDevPage from '@/pages/Development/RegistryDevPage'
import GetterTestsDevPage from '@/pages/Development/GetterTestsDevPage'
import OptimizerInputDevPage from '@/pages/Development/OptimizerInputDevPage'

/* --------- Experiments --------- */
import TimeslotPage from "@/pages/Experiments/OldTimeTableCalendar";
import Experiments from "@/pages/Experiments/Experiments";
import TimezoneTests from "@/pages/Experiments/TimezoneTests";
import TimezoneMomentTests from "@/pages/Experiments/TimezoneMomentTests";
import I18nTests from "@/pages/Experiments/I18nTests";
import GanttTests from "@/pages/Experiments/GanttTests";
import TooltipTests from "@/pages/Experiments/TooltipTests";
import ElementUIDemo from '@/pages/Experiments/DemoElementUI'
import MasonryTest from '@/pages/Experiments/MasonryTest'
// TODO: Tiles from Tiles branch !

/* --------- Default Handler --------- */
import PageNotFound from '@/pages/PageNotFound'

const routes = [

  /* ============================ Login / Register ============================ */
  /* TODO: Code splitting? */
  {
    path: "/login",
    component: Login,
    meta: { requiresNoAuth: true, layout: 'empty' },
    name: "login"
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    meta: { requiresNoAuth: true, layout: 'empty' },
    name: "forgot-password"
  },
  {
    path: "/register",
    component: Register,
    meta: { requiresNoAuth: true, layout: 'empty' },
    name: "register"
  },
  {
    path: "/confirm-invitation",
    component: InvitationCode,
    meta: { requiresNoAuth: false, layout: 'empty' },
    name: "confirm-invitation"
  },
  {
    path: "/wait", // For testing only!?
    component: WaitingForAccount,
    meta: { requiresNoAuth: false, layout: 'empty' },
    name: "wait",
  },
  {
    path: "/upgrade",
    component: UpgradePage,
    meta: { requiresNoAuth: true }, // layout: 'empty'
    name: "upgrade"
  },

  /* ============================ Final Version ============================ */
  {
     path: "/",
     redirect: { name: 'overview' }
  },
  {
    path: "/overview",
    component: OverviewPage,
    name: 'overview'
  },
  {
    path: "/dayplanner",
    name: 'dayplanner',
    component: MyDay_Subpage,
    meta: {
      cacheKey: 'dayplanner',
    },
    children: [
      {
        path: "/dayplanner/goal/:goalId/member/:memberId/task/:taskId",
        alias: "/dayplanner/goal/:goalId/member/:memberId/task-template/:taskId",
        component: MyDay_Subpage,
        name: 'dayplanner-taskpage',
        meta: {
          showTask: true,
          // cacheKey: 'task-{taskId}',
          cacheKey: 'dayplanner',
        },
      },
       // TODO: Sequence items
    ]
  },
  {
    path: "/weekplanner",
    name: 'weekplanner',
    component: MyDay_Subpage,
  },
  {
    path: "/monthplanner",
    name: 'monthplanner',
    component: MyDay_Subpage,
  },
  {
    path: "/today",
    component: CalendarLayout,
    meta: { calendarLayout: 'narrow', cacheKey: 'calendar' },
    name: 'today',
    redirect: '/today/goals',
    children: [
      {
        path: 'goals',
        components: { default: MyDay_Subpage },
        meta: {
          calendarLayout: 'narrow',
          cacheKey: 'calendar',
          buttons: ['calendar']
        },
      },
      {
        path: 'priorities',
        components: { default: MyDailyPriorities_Subpage },
        meta: {
          calendarLayout: 'narrow',
          cacheKey: 'calendar',
          buttons: ['calendar']
        },
      },
      /*
      {
        path: "/goal/:goalId/member/:memberId/task/:taskId", // TODO
        components: { default: TaskPage },
        meta: { calendarLayout: 'narrow', cacheKey: 'task-{taskId}' },
      },
      {
        path: "/goal/:goalId/sequence/:sequenceId/item/:sequenceItemId",
        components: { default: TaskPage },
        meta: { calendarLayout: 'narrow', cacheKey: 'task2-{sequenceId}-{sequenceItemId}' },
      },
      */
    ]
  },
  // {
  //   path: "/goal/:goalId/task/:taskId",
  //   component: TaskPage,
  //   name: 'task_view' // TODO
  // },
  {
    path: "/commitments",
    component: CalendarPage_ManageTimeSubpage,
    name: 'manage_week'
  },
  {
    alias: '/today',
    path: '/calendar/',
    component: CalendarLayout,
    meta: {
      calendarLayout: 'wide',
      cacheKey: 'calendar',
      buttons: []
    },
    name: 'calendar',
    redirect: '/calendar/manage-time-and-priorities',
    children: [
      {
        path: 'manage-time-and-priorities',
        components: { header: CalendarPage, default: CalendarPage_ManageWeekSubpage },
        meta: {
          calendarLayout: 'wide',
          cacheKey: 'calendar',
          buttons: ['sidebar']
        },
      },
      {
        components: { default: CalendarPage_ManageTimeSubpage },
        path: 'manage-week',
        meta: {
          calendarLayout: 'wide',
          cacheKey: 'calendar',
          buttons: ['sidebar']
        },
      },
      /*
      {
        path: 'draft',
        components: { default: CalendarPage_SidebarSubpage },
        meta: {
          calendarLayout: 'wide',
          cacheKey: 'calendar',
          buttons: ['sidebar','calendar']
        },
        name: 'calendar_draft'
      }
      */
    ]
  },
  {
    path: "/visionboards",
    component: VisionboardOverviewPage,
    name: 'visionboard_overview'
  },
  {
    path: "/visionboard/:visionboardId?",
    component: VisionboardPage,
    name: 'visionboard'
  },
  {
    path: "/goals",
    component: GoalOverview,
    name: 'goal_overview'
  },
  {
    path: '/goal/:goalId',
    component: TeamGoalPage,
    name: 'goal',
    redirect: '/goal/:goalId/dashboard',
    meta: {
      showTaskAsOverlay: true,
      cacheKey: 'kanban',
      isDark: true,
    },
    children: [
      {
        // TeamGoalDashboardSubpage will be rendered inside the Goal's <router-view>
        // when /goal/:id/posts is matched
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardPage,
        meta: {
          cacheKey: 'kanban',
          isDark: true,
        },
      },
      {
        path: 'kanban',
        name: 'kanban',
        component: DashboardPage, // TeamGoal_KanbanSubpage
        meta: {
          cacheKey: 'kanban',
          isDark: true,
        },
      },
      {
        path: 'timeline',
        name: 'timeline',
        component: TeamGoal_TimelineSubpage,
        meta: {
          isDark: true,
        },
      },
      {
        path: 'reports',
        name: 'reports',
        component: TeamGoal_ReportsSubpage,
        meta: {
          isDark: true,
        },
      },
      {
        path: 'settings',
        name: 'settings',
        component: TeamGoal_SettingsSubpage,
        meta: {
          isDark: true,
        },
      },
      {
        path: "/taskdetails/goal/:goalId/member/:memberId/task/:taskId",
        alias: "/taskdetails/goal/:goalId/member/:memberId/task-template/:taskId",
        components: { default: TaskPage },
        name: 'taskpage-details',
        meta: {
          cacheKey: 'task-{taskId}',
        },
      },
      {
        path: "/goal/:goalId/member/:memberId/task/:taskId",
        /* Careful: Id's in alias must be the same as in path! */
        alias: "/goal/:goalId/member/:memberId/task-template/:taskId",
        component: DashboardPage,
        // components: { default: TaskPage },
        name: 'taskpage',
        meta: {
          isDark: true,
          showTask: true,
          // calendarLayout: 'narrow',
          // buttons: ['sidebar', 'calendar']
          // cacheKey: 'task-{taskId}',
          cacheKey: 'kanban',
          showTaskAsOverlay: true,
        },
      },
      {
        path: "/goal/:goalId/sequence/:sequenceId/item/:sequenceItemId",
        components: { default: TaskPage },
        name: 'taskpage-sequence',
        meta: {
          // calendarLayout: 'narrow',
          // buttons: ['sidebar', 'calendar']
          cacheKey: 'task2-{sequenceId}-{sequenceItemId}', // TODO
          showTaskAsOverlay: true,
        },
      },
    ]
  },
  {
    path: "/challenges/:page?",
    component: ChallengeCatalogPage,
    name: 'challenge_catalog'
  },
  {
    path: '/challenge/:challengeId',
    component: ChallengePage,
    name: 'challenge',
    redirect: '/challenge/:goalId/dashboard',
    children: [
      {
        path: 'dashboard',
        component: Challenge_DashboardSubpage
      },
      {
        path: 'discussion-faq',
        component: Challenge_DiscussionSubpage
      },
      {
        path: 'cohort',
        component: Challenge_CohortSubpage
      },
      {
        path: 'success-stories',
        component: Challenge_SuccessStoriesSubpage
      },
      {
        path: 'sessions',
        component: Challenge_SessionsSubpage
      }
    ]
  },
  {
    alias: "/sequences",
    path: "/sequence/:sequenceId?",
    component: SequenceCreatorPage,
    name: 'sequence_creator',
    children: [
      {
        path: 'preview',
        component: SequenceCreator_PreviewSubpage
      },
      {
        path: 'editor',
        component: SequenceCreator_EditorSubpage,
        name: 'edit_sequence'
      }
    ]
  },
  {
    path: "/ideas",
    component: IdeasPage,
    name: 'ideas'
  },
  {
    path: "/feature-request",
    component: MostWantedFeaturePage,
    name: 'most_wanted_feature'
  },
  {
    path: "/invitations",
    component: InvitationsPage,
    name: 'invitations'
  },
  {
    path: "/profile",
    component: UserProfilePage,
    name: 'profile'
  },
  {
    path: "/licenses",
    component: ManageLicensesPage,
    name: 'licenses'
  },
  { // <<< TODO
    path: "/user/:userId",
    component: UserContactPage,
    name: 'user'
  },
  {
    path: "/messages/:userId?",
    component: MessagesPage,
    name: 'messages'
  },
  {
    path: "/help",
    component: HelpPage
  },
  {
    path: '/terms-and-privacy',
    name: 'terms_and_privacy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/pages/TermsAndPrivacyPage.vue')
  },

  /* ============================ Draft ============================ */
  // TODO: Create chunk
  // { path: "/draft/lanes", component: LanesPageAllGoals, name: 'lanes', meta: { requiresFlexGrid: true } },
  { path: "/draft/kanban/:goalId", component: KanbanPage, name: 'kanban-old' }, /* meta: { requiresFlexGrid: true } */
  { path: "/draft/goal/:goalId", component: GoalPage, name: 'goal-draft' },
  { path: "/draft/timeslot", component: TimeslotPage, name: 'timeslot' },
  // { path: "/draft/calendar", component: CalendarPageDraft, name: 'calendar-draft' },
  { path: "/draft/session/:sessionId?", component: SessionPage, name: 'session' },
  { path: "/draft/focus/", component: FocusPage, name: 'focus' },
  { path: "/draft/user/:userId", component: UserPage, name: 'user-draft' },
  // { path: "/draft/projects", component: ProjectLanesPage },
  { path: "/draft/eggtimer/:time?", component: EggtimerPage },
  { path: "/draft/daily-checklist", component: DailyChecklistPage },

  /* ============================ Development ============================ */
  // TODO: Create chunk
  { path: "/dev/optimizer", component: OptimizerDevPage },
  // { path: "/dev/timeline", component: TimelineDevPage },
  { path: "/dev/generic-api", component: GenericAPIDevPage, name: "GenericAPI" },
  // { path: "/dev/ressource-dag", component: RessourceDAGDevPage, name: "RessourceDAG" },
  { path: "/dev/async-getter", component: AsyncGetterDevPage, name: "AsyncGetter" },
  { path: "/dev/registry", component: RegistryDevPage, name: "Registry" },
  { path: "/dev/getter-tests", component: GetterTestsDevPage, name: "GettersTests" },
  { path: "/dev/optimizer-input", component: OptimizerInputDevPage, name: "OptimizerInput" },
  // { path: "/dev/todo", component: ToDoList },

  /* ============================ Experiments ============================ */
  // TODO: Create chunk
  { path: "/experiments", component: Experiments },
  { path: "/experiments/elements", component: ElementUIDemo },
  { path: "/experiments/tz", component: TimezoneTests },
  { path: "/experiments/tz-moment", component: TimezoneMomentTests },
  { path: "/experiments/i18n", component: I18nTests },
  { path: "/experiments/gantt", component: GanttTests },
  { path: "/experiments/tooltip", component: TooltipTests },
  { path: "/experiments/masonry", component: MasonryTest },

  /* ========================== Default Handler ========================== */
  { path: "*", component: PageNotFound, layout: 'empty' }
];

export default routes;
